const CYRILLIC_TO_LATIN_MAP_RU: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'yo',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya'
}

const CYRILLIC_TO_LATIN_MAP_UK: Record<string, string> = {
  ...CYRILLIC_TO_LATIN_MAP_RU,
  г: 'h',
  и: 'y',
  і: 'i',
  ї: 'i',
  й: 'i',
  є: 'ye',
  ґ: 'g'
}

const getCyrillicToLatinMap = (language?: string) => {
  if (language === 'uk') {
    return CYRILLIC_TO_LATIN_MAP_UK
  }

  if (language === 'ru') {
    return CYRILLIC_TO_LATIN_MAP_RU
  }

  return null
}

export const normalizeForSearch = (value: string) => {
  if (!value) return ''

  return value
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase()
}

export const transliterateCyrillicToLatin = (value: string, language?: string) => {
  const map = getCyrillicToLatinMap(language)

  if (!value || !map) {
    return value
  }

  return Array.from(value.toLowerCase())
    .map((char) => map[char] ?? char)
    .join('')
}

export const buildOrigDestSearchAliases = (values: string[], language?: string) => {
  const aliases = values.flatMap((value) => {
    if (!value) {
      return []
    }

    const normalizedValue = normalizeForSearch(value)
    const normalizedTransliterated = normalizeForSearch(transliterateCyrillicToLatin(value, language))

    if (!normalizedTransliterated || normalizedTransliterated === normalizedValue) {
      return []
    }

    return [normalizedTransliterated]
  })

  return [...new Set(aliases.filter(Boolean))]
}
